import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_SMD: TStep[] = [
  {
    pageId: PageId.DOG_AGE_SMD,
  },
  {
    pageId: PageId.DOG_SEX_SMD,
  },
  {
    pageId: PageId.DOG_BREED_SMD,
  },
  {
    pageId: PageId.URGE_SMD,
  },
  {
    pageId: PageId.GOALS_SMD,
  },
  {
    pageId: PageId.URGE_1_SMD,
  },
  {
    pageId: PageId.AGRESSIVE_BEHAVIOR_SMD,
  },
  {
    pageId: PageId.TRIGGERS_SMD,
  },
  {
    pageId: PageId.URGE_2_SMD,
  },
  {
    pageId: PageId.BEHAVIOR_ISSUES_SMD,
  },
  {
    pageId: PageId.DOG_LISTEN_SMD,
  },
  {
    pageId: PageId.COMMANDS_SMD,
  },
  {
    pageId: PageId.EAT_OFF_THE_GROUND_SMD,
  },
  {
    pageId: PageId.DOG_ACT_SMD,
  },
  {
    pageId: PageId.DOG_OFF_AT_HOME_SMD,
  },
  {
    pageId: PageId.PREPARE_SCREEN_SMD,
  },
  {
    pageId: PageId.DOG_PROFILE_SMD,
  },
  {
    pageId: PageId.HEAR_ABOUT_WOOFZ_SMD,
  },
  {
    pageId: PageId.MANNERS_TO_BUILD_SMD,
  },
  {
    pageId: PageId.FEEL_BETTER_SMD,
  },
  {
    pageId: PageId.PREPARE_FLOW_SMD,
  },
  {
    pageId: PageId.EMAIL_SMD,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_SMD,
  },
  {
    pageId: PageId.SCRATCH_SCREEN_SMD,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_SMD,
  },
  {
    pageId: PageId.CHAT_UPSELL_SMD,
  },
  {
    pageId: PageId.UPSELL_SMD,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_SMD,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_SMD,
  },
  {
    pageId: PageId.DOWNLOAD_SMD,
  },
  {
    pageId: PageId.ACCOUNT_SMD,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_SMD.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_SMD.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
